// San Jose State's undergraduate majors (#2652, founder 2026-09-30: "majors
// offered by the college in the public page"). Read on 2026-10-01 from SJSU's
// official 2026-2027 Academic Catalog: the Academic Programs page's
// "Undergraduate Major(s)" list (navoid=8470), each line placed in its
// college by the catalog's Academic Programs by College page (navoid=8460),
// which is each group's source. The catalog lists each concentration as its
// own degree line, and SJSU ranks applicants per concentration, so each line
// stays an entry. Left out: SJSU Online degree-completion programs (separate
// application), lines marked "Not Accepting Students", the RN to BSN and
// ADN to BSN nursing pathways (for nurses already licensed or enrolled in an
// ADN program), SAGE combined degrees, minors and graduate programs. Every
// SJSU major is impacted (the college file's programs block says so); the
// Animation & Illustration flag and the engineering note quote SJSU's own
// pages (`steps`, `impaction`). The KB's list (a Fall 2025 PDF) was the
// starting point; the catalog wins.
const majors = {
    "slug": "san-jose-state-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in SJSU's official 2026-2027 Academic Catalog, grouped by the college that offers it, with the degree it leads to. Concentrations are listed as the catalog lists them; online degree-completion programs, programs not accepting students, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Lucas College and Graduate School of Business",
            "source": {
                "label": "SJSU 2026-2027 Academic Catalog, Academic Programs by College",
                "url": "https://catalog.sjsu.edu/content.php?catoid=23&navoid=8460"
            },
            "majors": [
                {
                    "name": "Business Administration, Accounting Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Accounting Information Systems Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Business Analytics Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Corporate Accounting and Finance Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Entrepreneurship Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Finance Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, General Business Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Hospitality, Tourism and Event Management Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Human Resource Management Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, International Business Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Management Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Management Information Systems Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Marketing Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration, Operations and Supply Chain Management Concentration",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Connie L. Lurie College of Education",
            "source": {
                "label": "SJSU 2026-2027 Academic Catalog, Academic Programs by College",
                "url": "https://catalog.sjsu.edu/content.php?catoid=23&navoid=8460"
            },
            "majors": [
                {
                    "name": "Child and Adolescent Development",
                    "degree": "BA"
                },
                {
                    "name": "Child and Adolescent Development, PK-3 Integrated Teacher Education Program Spanish Bilingual",
                    "degree": "BA"
                },
                {
                    "name": "Child and Adolescent Development, PK-3 Integrated Teacher Education Program",
                    "degree": "BA"
                },
                {
                    "name": "Child and Adolescent Development, Preparation for Teaching W/CSET Waiver",
                    "degree": "BA"
                },
                {
                    "name": "Child and Adolescent Development, Preparation for Teaching",
                    "degree": "BA"
                },
                {
                    "name": "Communicative Disorders and Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Charles W. Davidson College of Engineering",
            "source": {
                "label": "SJSU 2026-2027 Academic Catalog, Academic Programs by College",
                "url": "https://catalog.sjsu.edu/content.php?catoid=23&navoid=8460"
            },
            "note": "Applicants are ranked with a modified impaction index that adds math GPA.",
            "noteSource": "impaction",
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Aviation",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Technology, Computer Network System Management (CNSM) Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Technology, Manufacturing Systems Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Health and Human Sciences",
            "source": {
                "label": "SJSU 2026-2027 Academic Catalog, Academic Programs by College",
                "url": "https://catalog.sjsu.edu/content.php?catoid=23&navoid=8460"
            },
            "majors": [
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology, Preparation for Teaching",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Science, Applied Nutrition and Food Sciences Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Science, Dietetics Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Packaging",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Public Health, Concentration in Community Health Education",
                    "degree": "BS"
                },
                {
                    "name": "Public Health, Concentration in Population Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Humanities and the Arts",
            "source": {
                "label": "SJSU 2026-2027 Academic Catalog, Academic Programs by College",
                "url": "https://catalog.sjsu.edu/content.php?catoid=23&navoid=8460"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "BS"
                },
                {
                    "name": "Animation & Illustration",
                    "degree": "BFA",
                    "flag": "Three short supplemental drawing exercises are a required part of the application for this major, due one week after the Cal State Apply deadline.",
                    "flagSource": "steps"
                },
                {
                    "name": "Art History and Visual Culture",
                    "degree": "BA"
                },
                {
                    "name": "Art, Digital Media Art Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Art, Photography Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Art, Pictorial Art Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Art, Spatial Art Concentration",
                    "degree": "BFA"
                },
                {
                    "name": "Art, Studio Practice Concentration (Preparation for Teaching)",
                    "degree": "BA"
                },
                {
                    "name": "Art, Studio Practice Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Creative Arts",
                    "degree": "BA"
                },
                {
                    "name": "Creative Arts, Creative Arts Therapy Studies Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Design Studies",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English, Creative Writing Concentration",
                    "degree": "BA"
                },
                {
                    "name": "English, Preparation for Teaching (Single Subject)",
                    "degree": "BA"
                },
                {
                    "name": "English, Professional and Technical Writing Concentration",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Humanities, American Studies Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Humanities, Liberal Arts Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Humanities, Religious Studies Concentration",
                    "degree": "BA"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BS"
                },
                {
                    "name": "Interior Design",
                    "degree": "BFA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Liberal Studies, Integrated Teacher Education Program Spanish Bilingual",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Studies, Integrated Teacher Education Program",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Studies, Preparation for Teaching",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Music Technology",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music, Composition Concentration",
                    "degree": "BM"
                },
                {
                    "name": "Music, Jazz Studies Concentration",
                    "degree": "BM"
                },
                {
                    "name": "Music, Music Teacher Preparation Concentration",
                    "degree": "BM"
                },
                {
                    "name": "Music, Performance Concentration",
                    "degree": "BM"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations",
                    "degree": "BS"
                },
                {
                    "name": "Radio-Television-Film",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Information, Data and Society",
            "source": {
                "label": "SJSU 2026-2027 Academic Catalog, Academic Programs by College",
                "url": "https://catalog.sjsu.edu/content.php?catoid=23&navoid=8460"
            },
            "majors": [
                {
                    "name": "Information Science and Data Analytics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "SJSU 2026-2027 Academic Catalog, Academic Programs by College",
                "url": "https://catalog.sjsu.edu/content.php?catoid=23&navoid=8460"
            },
            "majors": [
                {
                    "name": "Applied Mathematics, Computational Science Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics, Discrete Mathematics Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences - Ecology and Evolution",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences - Marine Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences, Microbiology Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences, Molecular Biology Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences, Systems Physiology Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry, Biochemistry Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Climate Science",
                    "degree": "BS"
                },
                {
                    "name": "Computational Biology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Geology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Linguistics",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Earth System Science",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics, Integrated Teacher Education Program",
                    "degree": "BA"
                },
                {
                    "name": "Meteorology",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics, Preparation for Teaching",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Social Sciences",
            "source": {
                "label": "SJSU 2026-2027 Academic Catalog, Academic Programs by College",
                "url": "https://catalog.sjsu.edu/content.php?catoid=23&navoid=8460"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Asian American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Behavioral Science",
                    "degree": "BA"
                },
                {
                    "name": "Chicana and Chicano Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies, Preparation for Teaching",
                    "degree": "BA"
                },
                {
                    "name": "Forensic Science, Biology Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Forensic Science, Chemistry Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Forensic Science, Crime Scene Investigation Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Forensic Science, Digital Evidence Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Justice Studies",
                    "degree": "BS"
                },
                {
                    "name": "Justice Studies, Criminology Concentration",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Social Science, Preparation for Teaching (Single Subject)",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Graduate Studies",
            "source": {
                "label": "SJSU 2026-2027 Academic Catalog, Academic Programs by College",
                "url": "https://catalog.sjsu.edu/content.php?catoid=23&navoid=8460"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
